<template lang="pug">
.form-container
  h4 {{ $t('Edit group')}} {{desktopGroup.name}}
  hr.header
  el-form.edit-group-form(v-if='desktopGroupData', label-width="100px")
    el-form-item(:label="$t('Name')")
      el-input(id="GroupEdit-nameInput", v-model='desktopGroupData.name')
    el-form-item(:label="$t('Address')")
      el-input(id="GroupEdit-addressInput", v-model='desktopGroupData.address')
    el-form-item(:label="$t('Latitude')")
      el-input(id="GroupEdit-latitudeInput", v-model='desktopGroupData.latitude')
    el-form-item(:label="$t('Longitude')")
      el-input(id="GroupEdit-longitudeInput", v-model='desktopGroupData.longitude')
    el-form-item
      el-button-group.float-right
        el-button(id="GroupEdit-saveButton", @click='updateGroup()', type="success", size="small", :title="$t('Save group name')", :disabled="isSaving")
          font-awesome-icon(icon="save")
          span &nbsp; {{isSaving ? $t('saving...') : $t('save group')}}
        el-button(id="GroupEdit-deleteButton", v-if='desktopGroupData.DeviceDesktops.length === 0', @click='deleteGroup()', type="success", size="small", :title="$t('delete group')")
          font-awesome-icon(icon="trash")
          span &nbsp; {{$t('delete group')}}
</template>

<script>

import Vue from 'vue'

export default {
  mixins: [],
  props: ['desktopGroup'],
  components: {
  },
  watch: {
  },
  data () {
    return {
      errors: {
      },
      isSaving: false,
      desktopGroupData: JSON.parse(JSON.stringify(this.desktopGroup))
    }
  },
  methods: {
    async updateGroup () {
      this.isSaving = true
      await Vue.axios
        .patch(
          `devicedesktopgroup/${this.desktopGroup.id}`,
          {
            address: this.desktopGroupData.address,
            latitude: this.desktopGroupData.latitude,
            longitude: this.desktopGroupData.longitude,
            name: this.desktopGroupData.name
          }
        )
        .then(response => {
          this.$store.commit('Device/UPDATE_DEVICE_DESKTOP_GROUPS', response.data, { root: true })
        })
      this.isSaving = false
      this.showGroupDataEditor = false
    },
    async deleteGroup () {
      await Vue.axios.delete(`devicedesktopgroup/${this.desktopGroup.id}`)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/GroupEdit.vue